class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if($(".js-hero-swiper").length != 0) {
      new Swiper(".js-hero-swiper", {
        loop: true,
        slidesPerView: 1.15,
        centeredSlides: true,
        loopAdditionalSlides: 10,
        speed: 1000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        breakpoint: {
          768: {
            slidesPerView: 1.4,
          }
        }
      });
    };

    if($(".js-business-swiper").length != 0) {
      new Swiper(".js-business-swiper", {
        loop: true,
        slidesPerView: 1.2,
        centeredSlides: true,
        loopAdditionalSlides: 10,
        speed: 600,
        pagination: {
          el: ".js-business-swiper-pagination",
          clickable: true
        },
        navigation: {
          prevEl: ".js-business-swiper-prev",
          nextEl: ".js-business-swiper-next"
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            centeredSlides: false,
          }
        }
      });
    };

    // SP hamburger menu
    const $spHeader = $('.js-sp-header');
    const $menuBtn  = $('.js-sp-menu-btn');

    const closeMenu = function() {
      const scrollY = -parseInt($('html').css('top') || '0', 10);
      $menuBtn.removeClass('is-open');
      $spHeader.removeClass('is-open');
      $('html').removeClass('is-hidden').css('top', '');
      window.scrollTo({ top: scrollY, behavior: 'instant' });
    };

    $menuBtn.on('click', function() {
      const isOpen = $(this).hasClass('is-open');
      if (!isOpen) {
        const scrollY = window.scrollY;
        $(this).addClass('is-open');
        $spHeader.addClass('is-open');
        $('html').css('top', -scrollY + 'px').addClass('is-hidden');
      } else {
        closeMenu();
      }
    });

    // メニュー内リンクをタップしたら閉じる
    $spHeader.find('a').on('click', function() {
      closeMenu();
    });

    // 注目の返礼品 - product tab switching
    let isProductTabAnimating = false;

    $('.js-product-thumb').on('click', function() {
      if (isProductTabAnimating) return;

      const idx        = $(this).data('product-idx');
      const $container = $(this).closest('[data-tab-content]');
      const $next      = $container.find('[data-product-panel="' + idx + '"]');

      if ($next.length === 0 || !$next.hasClass('hidden')) return;

      isProductTabAnimating = true;

      $container.find('.js-product-thumb').removeClass('is-active');
      $(this).addClass('is-active');

      const $current = $container.find('.js-product-panel:not(.hidden)').stop(true);

      $current.animate({ opacity: 0 }, 250).promise().done(function() {
        $current.addClass('hidden').css({ opacity: '', display: '' });
        $next.css({ display: 'grid', opacity: 0 }).removeClass('hidden')
          .animate({ opacity: 1 }, 300, function() {
            isProductTabAnimating = false;
          });
      });
    });

    $('.js-accordion-trigger').on('click', function(){
      $(this).toggleClass('is-active');
      $(this).next().slideToggle();
    });

    if ($('.js-scroll-hint-wrap').length) {
      new ScrollHint('.js-scroll-hint-wrap', {
        suggestiveShadow: true,
        i18n: {
          scrollable: 'スクロールできます'
        }
      });
    }
  }
}
